import Reveal from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "TABA turned an empty school corridor into the most loved room on campus. The kids still stop and stare.",
    name: "Allen Institute",
    role: "CSR Initiative",
  },
  {
    quote:
      "From the first brushstroke to the last, the entire process felt collaborative. The walls feel like ours now.",
    name: "Adwait Foundation",
    role: "Cultural Programming",
  },
  {
    quote:
      "What sets them apart is their versatility — café walls, school walls, even government flyovers. Always with intent.",
    name: "Martini Cafe",
    role: "Hospitality",
  },
  {
    quote:
      "A small team with a big, careful hand. We commissioned them twice, and we'll keep coming back.",
    name: "Renukiran Foundation",
    role: "Education Outreach",
  },
];

export default function Testimonials() {
  return (
    <section className="relative py-24 md:py-40 px-5 md:px-10 bg-[var(--bg-soft)] overflow-hidden">
      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-6">
            <Reveal>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)]">
                — Words from walls
              </div>
              <h2 className="mt-3 font-display font-light text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.05] tracking-tight text-[var(--bone)]">
                What our walls <span className="italic font-extralight">hear back.</span>
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 self-end">
            <Reveal delay={120}>
              <p className="text-[var(--muted)] text-[15px] leading-relaxed">
                A short note from the people who live with our work — schools,
                cafés, foundations, governments.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-[var(--line)] border-t border-b border-[var(--line)]">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 80}>
              <figure className="bg-[var(--bg-soft)] p-8 md:p-12 h-full hover:bg-[var(--bg-elevated)] transition-colors">
                <svg width="32" height="24" viewBox="0 0 32 24" fill="none" className="text-[var(--clay)] mb-6">
                  <path d="M0 24V13.5C0 6 4.5 0 13.5 0v6c-4.5 0-7.5 3-7.5 7.5h7.5V24H0zm18.5 0V13.5C18.5 6 23 0 32 0v6c-4.5 0-7.5 3-7.5 7.5H32V24H18.5z" fill="currentColor"/>
                </svg>
                <blockquote className="font-display text-2xl md:text-3xl text-[var(--bone)] leading-snug">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-8 flex items-center gap-3">
                  <span className="w-8 h-px bg-[var(--clay)]" />
                  <div>
                    <div className="text-[var(--bone)] text-sm">{t.name}</div>
                    <div className="text-[var(--muted)] text-xs uppercase tracking-[0.28em] mt-1">
                      {t.role}
                    </div>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}